import { render, staticRenderFns } from "./HaAccommodationsReview.vue?vue&type=template&id=55aec348&scoped=true&"
import script from "./HaAccommodationsReview.vue?vue&type=script&lang=js&"
export * from "./HaAccommodationsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aec348",
  null
  
)

export default component.exports